export const resetPasswordErrors = Object.freeze({
  INVALID_TOKEN: 'Código de reset inválido',
  PASSWORD_TOO_SIMPLE: 'Palavra-passe muito simples',
  EXPIRED_TOKEN: 'Código de reset expirou, solicite novo código',
});

export const passwordStrengthLabels = Object.freeze([
  'very_weak', 'weak', 'medium', 'strong',
]);

export const passwordStrengthColors = Object.freeze([
  '#d01818', '#e56625', '#e59f20', '#20e538',
]);

// The server rejects longer passwords with a Joi validation error (customer register, login and reset)
export const MAX_PASSWORD_LENGTH = 30;
